/**
 * Mensaje de error legible desde respuestas tipo `WrapperResponse` (next con `ok: false`).
 */
export function apiFailureMessage(r: { message?: string | null }, fallback: string): string {
  const m = r?.message;
  if (m != null && String(m).trim() !== '') {
    return String(m).trim();
  }
  return fallback;
}

/**
 * Mensaje desde fallo HTTP cuando el cuerpo es (o incluye) un wrapper con `message`.
 */
export function httpErrorApiMessage(err: unknown, fallback: string): string {
  const e = err as {
    error?: { message?: string } | string;
    message?: string;
  } | null;
  if (e?.error != null && typeof e.error === 'object' && typeof e.error.message === 'string') {
    const m = e.error.message.trim();
    if (m) return m;
  }
  if (typeof e?.message === 'string' && e.message.trim()) {
    return e.message.trim();
  }
  return fallback;
}

/**
 * Obtiene el nombre de archivo de la cabecera `Content-Disposition` (RFC 5987 `filename*` o `filename=`).
 */
export function parseContentDispositionFilename(header: string | null | undefined): string | null {
  if (header == null || String(header).trim() === '') return null;
  const h = String(header).trim();
  const star = /filename\*=(?:UTF-8''|)([^;\n]+)/i.exec(h);
  if (star?.[1]) {
    const raw = star[1].trim().replace(/^["']|["']$/g, '');
    try {
      return decodeURIComponent(raw);
    } catch {
      return raw || null;
    }
  }
  const plain = /filename=(["']?)([^";\n]+)\1/i.exec(h);
  const name = plain?.[2]?.trim();
  return name && name.length > 0 ? name : null;
}
